import React, { useState, useEffect } from "react";

import { BsStopwatch } from "react-icons/bs";
import { GiStopwatch } from "react-icons/gi";
import {
  FIRST_EXTRA_TIME,
  FIRST_HALF_KICK_OFF,
  kFT,
  kHT,
  kPK,
  LIVE_MATCH_FULL_TIME_STATUS,
  LIVE_MATCH_HALF_TIME_STATUS,
  LIVE_MATCH_PENALTIES_STATUS,
  LIVE_MATCH_UPCOMING_STATUS,
  SECOND_EXTRA_TIME,
  SECOND_HALF_KICK_OFF,
} from "../../../utils/constants/names";
import { LiveMatchDividerH } from "../../common/RedDividerH";
import LiveMatchCountdownTimer from "./LiveMatchCountdownTimer";
import LiveMatchStopWatch from "./LiveMatchStopWatch";

const LiveMatchTimer = ({
  matchStatus,
  loadingFixtureInfo,
  minutesPlayed,
  fixtureDateTime,
}) => {
  const [resetTimerToCurrentMinutePlayed, setResetTimerToCurrentMinutePlayed] =
    useState(false);
  const countdownTime = new Date(fixtureDateTime);
  countdownTime.setSeconds(countdownTime.getSeconds() + 60);

  const minutesInSeconds = loadingFixtureInfo ? 0 : minutesPlayed * 60;

  const minutesPlayedInSeconds = new Date();
  minutesPlayedInSeconds.setSeconds(
    minutesPlayedInSeconds.getSeconds() + minutesInSeconds
  );

  useEffect(() => {
    setResetTimerToCurrentMinutePlayed(true);
  }, [minutesPlayed]);

  return (
    <>
      <div className="rounded-full bg-gray-700 absolute top-[17vh] sm:top-[34vh] md:top-[32vh] lg:top-[32vh] xl:top-[32vh] 2xl:top-[46vh] mx-auto max-w-prose left-10 right-10 h-24 w-24 text-center ">
        <div className="flex flex-col justify-center items-center absolute top-5 left-5 right-5">
          <BsStopwatch size={24} color="#3b82f6" />
          <LiveMatchDividerH />
          <div className="mt-2">
            {matchStatus === LIVE_MATCH_UPCOMING_STATUS ? (
              <p className="text-gray-50 font-semibold">
                {loadingFixtureInfo ? (
                  <GiStopwatch size={24} color="#a3a3a3" />
                ) : (
                  <LiveMatchCountdownTimer expiryTimestamp={countdownTime} />
                )}
              </p>
            ) : matchStatus === FIRST_HALF_KICK_OFF ||
              matchStatus === FIRST_EXTRA_TIME ||
              matchStatus === SECOND_HALF_KICK_OFF ||
              matchStatus === SECOND_EXTRA_TIME ? (
              <p className="text-gray-50 font-semibold animate-pulse">
                {loadingFixtureInfo ? (
                  <GiStopwatch size={24} color="#a3a3a3" />
                ) : (
                  minutesPlayed
                  // <LiveMatchStopWatch
                  //   minutesPlayed={minutesPlayedInSeconds}
                  //   restartTimer={resetTimerToCurrentMinutePlayed}
                  // />
                )}
              </p>
            ) : matchStatus === LIVE_MATCH_HALF_TIME_STATUS ? (
              <p className="text-gray-50 font-semibold">{kHT}</p>
            ) : matchStatus === LIVE_MATCH_FULL_TIME_STATUS ? (
              <p className="text-gray-50 font-semibold">{kFT}</p>
            ) : matchStatus === LIVE_MATCH_PENALTIES_STATUS ? (
              <p className="text-gray-50 font-semibold">{kPK}</p>
            ) : (
              <GiStopwatch size={24} color="#a3a3a3" />
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default LiveMatchTimer;
